import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllClienteCadastro } from '../service';
import {
  LIST_CLIENTE_CADASTRO,
  LIST_CLIENTE_CADASTRO_PENDING,
  LIST_CLIENTE_CADASTRO_SUCCESS,
  LIST_CLIENTE_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListAllClienteCadastro(action) {
  yield put({ type: LIST_CLIENTE_CADASTRO_PENDING })

  try {
    const list = yield call(findAllClienteCadastro)
    
    yield put({ type: LIST_CLIENTE_CADASTRO_SUCCESS, list: list })
  } catch (error) {

    yield put({ type: LIST_CLIENTE_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllClienteCadastro() {
  yield takeLatest(LIST_CLIENTE_CADASTRO, sagaListAllClienteCadastro)
}